<template>
  <pl-module-box
    title="Our Current Research direction"
    class="researchDirection">
    <List
      :loading="loading"
      :data="data"
      :error="error">
        <template v-slot="{item, index}">
          <div class="reasearchItem" :key="item.id" @click="viewDetail(item)">
            <p class="title">{{index + 1}}.{{item.title}}</p>
          </div>
        </template>
    </List>
  </pl-module-box>
</template>

<script>
import { List } from 'components/common';
export default {
  components: {
    List
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Error,
      default: null,
    },
  },
  methods: {
    viewDetail (item) {
      localStorage.setItem('researchDetail', JSON.stringify(item));
      this.$router.push(`/research/${item.id}`);
    }
  },
}
</script>

<style lang="less" scoped>
  @import url('~@/assets/styles/vars.less');
  .researchDirection {
    font-family: @font-fm-head;
    background: transparent;
    box-shadow: none;
    /deep/ .title-box .title {
      font-size: 21px;
      line-height: 39px;
    }
    /deep/ .content-box {
      padding: 0;
      margin-top: 10px;
    }
    .reasearchItem {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 12px;
      background-color: @color-secondary;
      box-shadow: 0 2px 2px #dedcdc;
      &:last-of-type {
        margin-bottom: 0;
      }
      .title {
        margin: 0;
        text-align: center;
        line-height: 1.2em;
         &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
</style>
